//React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//Fetch
import axios from "axios";
//Context
import { useAuthContext } from "../../../Hooks/useAuthContext";
//Icons
import {
    faAdd,
    faArrowLeft,
    faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//Notifications
import { toast } from "react-toastify";
//Components
import { FloatingLabel, Form } from "react-bootstrap";
import MainContainer from "../../../Components/Containers/MainContainer";
import Loading from "../../../Components/Loading/Loading";

import FormControl from "../../../Components/Forms/FormControl";
import FormCheck from "../../../Components/Forms/FormCheck"

export default function ExpenseReport() {
    const navigate = useNavigate();
    const { user, dispatch } = useAuthContext();

    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);


    const [userList, setUserList] = useState([]);

    const [weekCommencing, setWeekCommencing] = useState(startOfWeek(new Date()));
    const [weekCommencing2, setWeekCommencing2] = useState(startOfWeek(new Date()).toISOString("en-GB").split('T')[0]);
    const [selectedUserId, setSelectedUserId] = useState();

    const [expenseReport, setExpenseReport] = useState();

    function submitForm() {
        console.log("submit clicked", {weekCommencing, selectedUserId})
        axios.post(`https://${process.env.REACT_APP_IP}/api/timesheets/expensereport`,
            {
                WeekCommencing: weekCommencing.toISOString().split('T')[0],
                UserId: selectedUserId
            },
            {
                headers: { Authorization: `bearer ${user.token}` },
            }

        )
        .then((response) => {
            console.log("REsponse:", response.data)
            setExpenseReport(response.data);
        });

    };

    function startOfWeek(date) {
        // Calculate the difference between the date's day of the month and its day of the week
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);

        // Set the date to the start of the week by setting it to the calculated difference
        return new Date(date.setDate(diff));
    }

    const handleChangeDate = (e) => {
        console.log(e.target.value)
        var date = new Date(e.target.value)
        console.log(date)
        if (!isNaN(date) && date.getFullYear() > 2020) {
            console.log("date valid")
            setWeekCommencing(date);

        }
        else {
            console.log("invalid date")
        }
        console.log(e.target.value)
    };

    // ON LOAD - Load all users
    useEffect(() => {
        listUsers();
        setLoading(false);
    }, []);




    const listUsers = async () => {


        try {
            const res = await axios.get(`https://${process.env.REACT_APP_IP}/api/users`,
                {
                    headers: { Authorization: `bearer ${user.token}` },
                }
            );

            setUserList(res.data);
        } catch (error) {
            if (error.response.status === 401) {
                dispatch({ type: "LOGOUT" });
                navigate("../../expired");
            } else {
                setError(error.response.status);
            }
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = (e) => {
        e.preventDefault();
        window.print();
    };





    if (!loading) {
        return error ? (
            <MainContainer>Some error...</MainContainer>
        ) : (
            <MainContainer>
                

                    {/* Report Options Panel */}
                    <div style={{ border: "1px solid #ccc", backgroundColor: "#eee" }}  className="no-print">
                        <h4>Report Options</h4>
                        <div className="row">
                            <div className="col-4">
                                <Form.Group className="" >
                                    <div className="form-floating">
                                        <Form.Select onChange={(e) => setSelectedUserId(e.target.value)} value={selectedUserId}>
                                            <option disabled value="">Select user...</option>
                                            {userList.map((u) => (
                                                <option key={u.id} value={u.id}>
                                                    {u.firstName} {u.lastName}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <label>
                                            User 
                                        </label>
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-4">
                                <Form.Group className={`mb-1  p-1`}>
                                    <div className="form-floating">
                                        <input
                                            type="date"
                                            name="weekCommencing2"
                                            placeholder="Week Commencing"
                                            defaultValue={weekCommencing2}
                                            onChange={handleChangeDate}
                                            className="form-control"
                                        />
                                        <label>
                                            Week Commencing 
                                        </label>
                                    </div>
                                </Form.Group>
                            </div>
                           
                            <div className="col-2">
                                <button type="submit" className="btn btn-primary" onClick={submitForm}>Generate</button>
                            </div>
                        </div>
                    </div>


                    {/* Results */}
                    <div style={{marginTop: 40}}>
                    {expenseReport && (
                        <div>
                            <div className="d-flex gap-2">
                                <h4>Expense Report - {expenseReport.user}</h4>
                                <button className="btn btn-primary no-print" onClick={(e) => handlePrint(e)}>Print</button><br />
                            </div>
                                <strong>Week Commencing: {new Date(expenseReport.weekCommencing).toLocaleDateString("en-GB")}</strong>
                                
                            <table style={{minWidth: 600, marginTop: 40} }>
                                <tr>
                                    <th>Nominal Code</th>
                                    <th>Department Code</th>
                                    <th>Project Code</th>
                                    <th>Cost Code</th>
                                    <th>Cost</th>
                                </tr>

                                {expenseReport.data.map((report) => {
                                    return (
                                        <tr key={report.Id}>
                                            <td>{report.nominalCode}</td>
                                            <td>{report.departmentCode}</td>
                                            <td>{report.projectCode}</td>
                                            <td>{report.costCode}</td>
                                            <td>{report.cost}</td>
                                        </tr>
                                    )
                                })}

                            </table>
                        </div>
                    )}
                    </div>

                </MainContainer>
        );
    } else {
        return (
            <MainContainer>
                <Loading />
            </MainContainer>
        );
    }
}
